var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 58,
    viewBox: "0 0 46 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3125 3.5V46C28.3125 47.7595 29.7405 49.1875 31.5 49.1875C33.2595 49.1875 34.6875 47.7595 34.6875 46V3.5C34.6875 1.7405 33.2595 0.3125 31.5 0.3125C29.7405 0.3125 28.3125 1.7405 28.3125 3.5Z",
    fill: "#0049A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6875 54.5V12C17.6875 10.2405 16.2595 8.8125 14.5 8.8125C12.7405 8.8125 11.3125 10.2405 11.3125 12V54.5C11.3125 56.2595 12.7405 57.6875 14.5 57.6875C16.2595 57.6875 17.6875 56.2595 17.6875 54.5Z",
    fill: "#0049A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2474 5.75241L39.8724 16.3774C41.1134 17.6227 43.1364 17.6227 44.3774 16.3774C45.6227 15.1364 45.6227 13.1134 44.3774 11.8724L33.7524 1.24741C32.5114 0.00216413 30.4884 0.00216413 29.2474 1.24741C28.0022 2.48841 28.0022 4.51141 29.2474 5.75241Z",
    fill: "#0049A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7524 52.2474L6.12741 41.6224C4.88641 40.3772 2.86341 40.3772 1.62241 41.6224C0.377164 42.8634 0.377164 44.8864 1.62241 46.1274L12.2474 56.7524C13.4884 57.9977 15.5114 57.9977 16.7524 56.7524C17.9977 55.5114 17.9977 53.4884 16.7524 52.2474Z",
    fill: "#0049A3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataIcon);
export default __webpack_public_path__ + "static/media/dataIcon.36002f84b13c22cd063ae28fc5d55a58.svg";
export { ForwardRef as ReactComponent };